import { render, staticRenderFns } from "./SinglePaginate.vue?vue&type=template&id=038a1a55&scoped=true"
import script from "./SinglePaginate.vue?vue&type=script&lang=js"
export * from "./SinglePaginate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038a1a55",
  null
  
)

export default component.exports